export function initContact() {
    var Contact = Barba.BaseView.extend({

        namespace: 'page-contact',

        onEnter: function() {

        },

        onLeave: function() {

        }

    })

    Contact.init();

}
